import { render, staticRenderFns } from "./Templates.vue?vue&type=template&id=32a60ac6&"
import script from "./Templates.vue?vue&type=script&lang=js&"
export * from "./Templates.vue?vue&type=script&lang=js&"
import style0 from "./Templates.vue?vue&type=style&index=0&id=32a60ac6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports